import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { useHistory } from '@shared/providers/history-provider';
import { useState } from 'react';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../purchased-goods-routes';
import { getFoodReferrerLabel } from '../utils';
import { usePurchasedFoodAndDrinkTabs } from './tabs';

export default function PurchasedFoodAndDrinkLayout() {
  const navigate = useNavigate();
  const tabs = usePurchasedFoodAndDrinkTabs();
  const history = useHistory();
  const [referrer] = useState<string | undefined>(history.previousLocation);
  return (
    <Page name="Food and drink" title="Purchased Food and Drink">
      <PageHeader
        name="Food and drink"
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Purchased goods',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK),
          },
          {
            label: 'Food and drink',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK, {
              category: generatePath(
                purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK
              ),
            }),
          },
        ]}
        toolbar={
          referrer &&
          (referrer.startsWith('/purchased-goods/reports') ||
            referrer.startsWith('/company-reports/')) ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getFoodReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
